import { lazy } from 'react';
import * as TPExports from './tp';
import * as GDExports from './gd';
import * as WBExports from './wb';
import * as CMExports from './cm';

export const ModulesComponents = {
    tp: {
        RisksFiltering: lazy(() => import('./tp/components/risks-filtering')),
        TasksFiltering: lazy(() => import('./tp/components/tasks-filtering')),
        AllRisksActions: lazy(() => import('./tp/components/all-risks-actions')),
    },
    gd: {
        RisksFiltering: lazy(() => import('./gd/components/risks-filtering')),
        TasksFiltering: lazy(() => import('./gd/components/tasks-filtering')),
        AllRisksActions: lazy(() => import('./gd/components/all-risks-actions')),
        MyRisksActions: lazy(() => import('./gd/components/my-risks-actions'))
    },
    wb: {
        RisksFiltering: lazy(() => import('./wb/components/risks-filtering')),
        TasksFiltering: lazy(() => import('./wb/components/tasks-filtering')),
        AllRisksActions: lazy(() => import('./wb/components/all-risks-actions')),
    },
    cm: {
        RisksFiltering: lazy(() => import('./cm/components/risks-filtering')),
        TasksFiltering: lazy(() => import('./cm/components/tasks-filtering')),
        AllRisksActions: lazy(() => import('./cm/components/all-risks-actions')),
    }
}

export const ModulesActions = {
    tp: TPExports.Actions,
    gd: GDExports.Actions,
    wb: WBExports.Actions,
    cm: CMExports.Actions
}

export const ModulesApiRoutes = {
    tp: TPExports.APIRoutes,
    gd: GDExports.APIRoutes,
    wb: WBExports.APIRoutes,
    cm: CMExports.APIRoutes,
}